import { TbBellRingingFilled } from 'react-icons/tb'

import { Circle } from '@chakra-ui/react'

interface CallAvatarIProps {
  size: string
  fontSize: string
  colour?: string
  bgColor?: string
  border?: string
}

export const CallAvatar = ({
  size,
  fontSize,
  border = null,
  colour = 'red',
  bgColor = '#E3EEFA',
}: CallAvatarIProps) => {
  return (
    <Circle
      bgColor={bgColor}
      border={border}
      color={colour}
      fontSize={fontSize}
      fontWeight='bold'
      size={size}
    >
      <TbBellRingingFilled color='#E53E3E' size={42} />
    </Circle>
  )
}
